import React, { useEffect, useState } from 'react';
import GlobalTable from '../components/GlobalTable';
import { useLazyTable } from '../hooks/useLazyTable';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import axiosInstance from '../services/axiosInstance';
import { handleApiError } from '../components/apiErrorHandler';

const ProductPriceList = () => {
  const [data, setData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const { lazyParams, onPage, onSort, onFilter, queryParams } = useLazyTable({ rows: 15 });
  const [loading, setLoading] = useState(false);

  const loadData = () => {
    setLoading(true);
    axiosInstance.get('/api/product-pricelists/', { params: queryParams })
      .then(res => {
        setData(res.data.results || []);
        setTotalRecords(res.data.count || 0);
      })
      .catch(handleApiError)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadData();
  }, [queryParams]);

  const columns = [
    { Header: 'Product', accessor: 'product_name', filtered: true },
    { Header: 'Price List ID', accessor: 'price_list_id' },
    { Header: 'Selling Price', accessor: 'selling_price', dataType: 'currency' },
    { Header: 'Purchase Price', accessor: 'purchase_price', dataType: 'currency' },
    { Header: 'Effective Date', accessor: 'effective_date', dataType: 'date' },
    { 
        Header: 'Active', accessor: 'is_active', filtered: true,
        bodyTemplate: (rowData) => (
                            <Checkbox checked={rowData.is_active === true || rowData.is_active === 'Y'} disabled />
                        ),
    },
  ];

  return (
    <div className="containers">
      <GlobalTable
        columns={columns}
        data={data}
        loading={loading}
        tabletitle="Product Price List"
        showEditColumn={false}
        lazy
        totalRecords={totalRecords}
        lazyParams={lazyParams}
        onPage={onPage}
        onSort={onSort}
        onFilter={onFilter}
        headerAction={
          <Button icon="pi pi-refresh" label="Refresh" outlined onClick={loadData} />
        }
      />
    </div>
  );
};

export default ProductPriceList;